var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,15h10V1h-10V15z M6.4,3.5h5.5c0.4,0,0.8,0.3,0.8,0.8S12.3,5,11.9,5H6.4C6,5,5.7,4.7,5.7,4.2 S6,3.5,6.4,3.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 1,
    className: "st0",
    width: 1.5,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.2,0h-10C4,0,3.8,0,3.7,0.1C3.5,0,3.3,0,3.2,0H1.7c-0.6,0-1,0.4-1,1v14c0,0.6,0.4,1,1,1h1.5 c0.2,0,0.4,0,0.5-0.1C3.8,16,4,16,4.2,16h10c0.6,0,1-0.4,1-1V1C15.2,0.4,14.7,0,14.2,0z M3.2,15H1.7V1h1.5V15z M14.2,15h-10V1h10 V15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.4,5h5.5c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8H6.4C6,3.5,5.7,3.8,5.7,4.2S6,5,6.4,5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.bc05c1893774a78195eb48a0b2a3f1a0.svg";
export { ForwardRef as ReactComponent };